// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/utilities.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/forms.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for the Cricket Academy app */
/* Import theme system and utilities */

/* Layout container */
.layout-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main navbar - Mobile optimized */
.main-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  margin-bottom: 0 !important;
  height: var(--navbar-height);
}

/* Navbar brand - Truncate on mobile */
.main-navbar .navbar-brand {
  font-size: var(--font-size-lg);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100vw - 120px);
}

@media (min-width: 768px) {
  .main-navbar .navbar-brand {
    font-size: var(--font-size-xl);
    max-width: none;
  }
}

/* Navbar toggle button - Better touch target */
.main-navbar .navbar-toggler {
  min-height: var(--touch-target-min);
  min-width: var(--touch-target-min);
  padding: var(--spacing-sm);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Layout content wrapper */
.layout-content {
  display: flex;
  flex: 1;
  margin-top: var(--navbar-height);
}

/* Fixed drawer for desktop */
.fixed-drawer {
  width: var(--drawer-width-desktop);
  background-color: var(--bg-light);
  border-right: 1px solid var(--border-color);
  position: fixed;
  top: var(--navbar-height);
  left: 0;
  bottom: 0;
  z-index: 1020;
  overflow-y: auto;
  display: none;
}

@media (min-width: 992px) {
  .fixed-drawer {
    display: block;
  }
}

.drawer-header {
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-white);
}

.drawer-title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
}

.drawer-nav {
  padding: var(--spacing-sm) 0;
}

.drawer-link {
  padding: var(--spacing-md) var(--spacing-md);
  min-height: var(--touch-target-min);
  color: var(--text-primary);
  text-decoration: none;
  border: none;
  border-radius: 0;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

.drawer-link:hover {
  background-color: var(--bg-gray);
  color: var(--color-primary);
}

.drawer-link.active {
  background-color: var(--color-primary);
  color: white;
}

/* Drawer divider */
.drawer-divider {
  margin: var(--spacing-md) 0;
  border-color: var(--border-color);
}

/* Academy main link */
.drawer-academy-main {
  font-weight: 600;
  background-color: var(--bg-light);
  border-left: 3px solid var(--color-primary);
  color: var(--color-primary);
}

.drawer-academy-main:hover {
  background-color: var(--bg-gray);
  border-left-color: #0a58ca;
  color: #0a58ca;
}

/* Submenu */
.drawer-submenu {
  padding-left: var(--spacing-md);
  background-color: var(--bg-light);
  border-left: 2px solid var(--border-color);
  margin-left: var(--spacing-sm);
}

.drawer-sub-link {
  padding: var(--spacing-sm) var(--spacing-md);
  min-height: var(--touch-target-min);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  border-left: none;
  position: relative;
}

.drawer-sub-link:hover {
  background-color: var(--bg-gray);
  color: var(--color-primary);
}

.drawer-sub-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: var(--text-secondary);
  border-radius: 50%;
  margin-left: -0.5rem;
}

.drawer-sub-link:hover::before {
  background-color: var(--color-primary);
}

/* Main content area - Mobile first */
.main-content {
  flex: 1;
  margin-left: 0;
  padding: var(--content-padding-mobile);
  min-height: calc(100vh - var(--navbar-height));
  width: 100%;
}

@media (min-width: 992px) {
  .main-content {
    margin-left: var(--drawer-width-desktop);
    padding: var(--content-padding-desktop);
  }
}

/* Mobile offcanvas drawer improvements */
@media (max-width: 991.98px) {
  .offcanvas {
    width: 85vw !important;
    max-width: 320px;
  }
  
  .offcanvas-header {
    padding: var(--spacing-md);
    border-bottom: 1px solid var(--border-color);
  }
  
  .offcanvas-title {
    font-size: var(--font-size-lg);
    font-weight: 600;
  }
  
  .offcanvas-body {
    padding: var(--spacing-md);
  }
  
  .offcanvas-body .nav-link {
    padding: var(--spacing-md);
    min-height: var(--touch-target-min);
    font-size: var(--font-size-base);
    display: flex;
    align-items: center;
  }
  
  .offcanvas-body .drawer-sub-link {
    padding: var(--spacing-sm) var(--spacing-md);
    padding-left: calc(var(--spacing-md) + var(--spacing-md));
  }
}

/* Add Academy Card hover effect */
.add-academy-card {
  transition: all 0.2s ease-in-out;
  border: 2px dashed var(--border-color);
}

.add-academy-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--color-primary);
}

/* Icon styling - Responsive */
.bi {
  font-size: 1.2em;
}

@media (max-width: 767.98px) {
  .bi {
    font-size: 1.1em;
  }
}

/* Button icons */
.btn .bi {
  font-size: 1em;
}

/* Card icons */
.card .bi {
  font-size: 1.1em;
}

@media (max-width: 767.98px) {
  .card .bi {
    font-size: 1em;
  }
}

/* Ensure proper spacing for icon buttons */
.btn-sm .bi {
  margin-right: var(--spacing-xs);
}

/* Academy card styling */
.card {
  transition: all 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Mobile modal improvements */
@media (max-width: 767.98px) {
  .modal-dialog {
    margin: 0;
    max-width: 100%;
    height: 100%;
  }
  
  .modal-content {
    min-height: 100%;
    border-radius: 0;
    border: none;
  }
  
  .modal-header {
    padding: var(--spacing-md);
    border-bottom: 1px solid var(--border-color);
  }
  
  .modal-body {
    padding: var(--spacing-md);
    overflow-y: auto;
    flex: 1;
  }
  
  .modal-footer {
    padding: var(--spacing-md);
    border-top: 1px solid var(--border-color);
    flex-direction: column;
    gap: var(--spacing-sm);
  }
  
  .modal-footer .btn {
    width: 100%;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,sCAAsC;;AAKtC,qBAAqB;AACrB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;IAC9B,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,OAAO;EACP,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,OAAO;EACP,cAAc;EACd,sCAAsC;EACtC,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE;IACE,wCAAwC;IACxC,uCAAuC;EACzC;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,4CAA4C;EAC9C;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,4CAA4C;IAC5C,yDAAyD;EAC3D;AACF;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,2CAA2C;AAC3C;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE;IACE,SAAS;IACT,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,0BAA0B;IAC1B,yCAAyC;IACzC,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":["/* Custom styles for the Cricket Academy app */\n/* Import theme system and utilities */\n@import './styles/theme.css';\n@import './styles/utilities.css';\n@import './styles/forms.css';\n\n/* Layout container */\n.layout-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Main navbar - Mobile optimized */\n.main-navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1030;\n  margin-bottom: 0 !important;\n  height: var(--navbar-height);\n}\n\n/* Navbar brand - Truncate on mobile */\n.main-navbar .navbar-brand {\n  font-size: var(--font-size-lg);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100vw - 120px);\n}\n\n@media (min-width: 768px) {\n  .main-navbar .navbar-brand {\n    font-size: var(--font-size-xl);\n    max-width: none;\n  }\n}\n\n/* Navbar toggle button - Better touch target */\n.main-navbar .navbar-toggler {\n  min-height: var(--touch-target-min);\n  min-width: var(--touch-target-min);\n  padding: var(--spacing-sm);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Layout content wrapper */\n.layout-content {\n  display: flex;\n  flex: 1;\n  margin-top: var(--navbar-height);\n}\n\n/* Fixed drawer for desktop */\n.fixed-drawer {\n  width: var(--drawer-width-desktop);\n  background-color: var(--bg-light);\n  border-right: 1px solid var(--border-color);\n  position: fixed;\n  top: var(--navbar-height);\n  left: 0;\n  bottom: 0;\n  z-index: 1020;\n  overflow-y: auto;\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .fixed-drawer {\n    display: block;\n  }\n}\n\n.drawer-header {\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--border-color);\n  background-color: var(--bg-white);\n}\n\n.drawer-title {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.drawer-nav {\n  padding: var(--spacing-sm) 0;\n}\n\n.drawer-link {\n  padding: var(--spacing-md) var(--spacing-md);\n  min-height: var(--touch-target-min);\n  color: var(--text-primary);\n  text-decoration: none;\n  border: none;\n  border-radius: 0;\n  transition: all 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n}\n\n.drawer-link:hover {\n  background-color: var(--bg-gray);\n  color: var(--color-primary);\n}\n\n.drawer-link.active {\n  background-color: var(--color-primary);\n  color: white;\n}\n\n/* Drawer divider */\n.drawer-divider {\n  margin: var(--spacing-md) 0;\n  border-color: var(--border-color);\n}\n\n/* Academy main link */\n.drawer-academy-main {\n  font-weight: 600;\n  background-color: var(--bg-light);\n  border-left: 3px solid var(--color-primary);\n  color: var(--color-primary);\n}\n\n.drawer-academy-main:hover {\n  background-color: var(--bg-gray);\n  border-left-color: #0a58ca;\n  color: #0a58ca;\n}\n\n/* Submenu */\n.drawer-submenu {\n  padding-left: var(--spacing-md);\n  background-color: var(--bg-light);\n  border-left: 2px solid var(--border-color);\n  margin-left: var(--spacing-sm);\n}\n\n.drawer-sub-link {\n  padding: var(--spacing-sm) var(--spacing-md);\n  min-height: var(--touch-target-min);\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  border-left: none;\n  position: relative;\n}\n\n.drawer-sub-link:hover {\n  background-color: var(--bg-gray);\n  color: var(--color-primary);\n}\n\n.drawer-sub-link::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 4px;\n  background-color: var(--text-secondary);\n  border-radius: 50%;\n  margin-left: -0.5rem;\n}\n\n.drawer-sub-link:hover::before {\n  background-color: var(--color-primary);\n}\n\n/* Main content area - Mobile first */\n.main-content {\n  flex: 1;\n  margin-left: 0;\n  padding: var(--content-padding-mobile);\n  min-height: calc(100vh - var(--navbar-height));\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .main-content {\n    margin-left: var(--drawer-width-desktop);\n    padding: var(--content-padding-desktop);\n  }\n}\n\n/* Mobile offcanvas drawer improvements */\n@media (max-width: 991.98px) {\n  .offcanvas {\n    width: 85vw !important;\n    max-width: 320px;\n  }\n  \n  .offcanvas-header {\n    padding: var(--spacing-md);\n    border-bottom: 1px solid var(--border-color);\n  }\n  \n  .offcanvas-title {\n    font-size: var(--font-size-lg);\n    font-weight: 600;\n  }\n  \n  .offcanvas-body {\n    padding: var(--spacing-md);\n  }\n  \n  .offcanvas-body .nav-link {\n    padding: var(--spacing-md);\n    min-height: var(--touch-target-min);\n    font-size: var(--font-size-base);\n    display: flex;\n    align-items: center;\n  }\n  \n  .offcanvas-body .drawer-sub-link {\n    padding: var(--spacing-sm) var(--spacing-md);\n    padding-left: calc(var(--spacing-md) + var(--spacing-md));\n  }\n}\n\n/* Add Academy Card hover effect */\n.add-academy-card {\n  transition: all 0.2s ease-in-out;\n  border: 2px dashed var(--border-color);\n}\n\n.add-academy-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--color-primary);\n}\n\n/* Icon styling - Responsive */\n.bi {\n  font-size: 1.2em;\n}\n\n@media (max-width: 767.98px) {\n  .bi {\n    font-size: 1.1em;\n  }\n}\n\n/* Button icons */\n.btn .bi {\n  font-size: 1em;\n}\n\n/* Card icons */\n.card .bi {\n  font-size: 1.1em;\n}\n\n@media (max-width: 767.98px) {\n  .card .bi {\n    font-size: 1em;\n  }\n}\n\n/* Ensure proper spacing for icon buttons */\n.btn-sm .bi {\n  margin-right: var(--spacing-xs);\n}\n\n/* Academy card styling */\n.card {\n  transition: all 0.2s ease-in-out;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Mobile modal improvements */\n@media (max-width: 767.98px) {\n  .modal-dialog {\n    margin: 0;\n    max-width: 100%;\n    height: 100%;\n  }\n  \n  .modal-content {\n    min-height: 100%;\n    border-radius: 0;\n    border: none;\n  }\n  \n  .modal-header {\n    padding: var(--spacing-md);\n    border-bottom: 1px solid var(--border-color);\n  }\n  \n  .modal-body {\n    padding: var(--spacing-md);\n    overflow-y: auto;\n    flex: 1;\n  }\n  \n  .modal-footer {\n    padding: var(--spacing-md);\n    border-top: 1px solid var(--border-color);\n    flex-direction: column;\n    gap: var(--spacing-sm);\n  }\n  \n  .modal-footer .btn {\n    width: 100%;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
